import { render, staticRenderFns } from "./VehicleSlide.vue?vue&type=template&id=3c271a2b&"
import script from "./VehicleSlide.vue?vue&type=script&lang=js&"
export * from "./VehicleSlide.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports